export const identifyUserToAppsFlyer = (userId: string) => {
  if (window.AF) {
    window.AF('pba', 'setCustomerUserId', userId);
  }
};
